module.exports = __webpack_public_path__ + "static/img/2900_phase_function_Paper_PointsHejduk_Prediction.ed7b646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2900_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ZTme
// module chunks = 0